import React from 'react';

export const SearchIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      className="btn__icon f--shrink-zero"
      fill="none"
    >
      <g clipPath="url(#clip0_10592_37123)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5 5.625C1.5 3.34683 3.34683 1.5 5.625 1.5C7.90317 1.5 9.75 3.34683 9.75 5.625C9.75 6.75611 9.29474 7.78088 8.55747 8.52608C8.55196 8.53098 8.54657 8.53606 8.54129 8.54134C8.53602 8.54661 8.53093 8.552 8.52604 8.55751C7.78084 9.29476 6.75608 9.75 5.625 9.75C3.34683 9.75 1.5 7.90317 1.5 5.625ZM8.7968 9.32718C7.94423 10.0583 6.8362 10.5 5.625 10.5C2.93261 10.5 0.75 8.31739 0.75 5.625C0.75 2.93261 2.93261 0.75 5.625 0.75C8.31739 0.75 10.5 2.93261 10.5 5.625C10.5 6.83622 10.0583 7.94428 9.32714 8.79685L11.8901 11.3598C12.0366 11.5063 12.0366 11.7437 11.8901 11.8902C11.7437 12.0366 11.5062 12.0366 11.3598 11.8902L8.7968 9.32718Z"
          fill="#706F6F"
        />
      </g>
      <defs>
        <clipPath id="clip0_10592_37123">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
